module.exports = __webpack_public_path__ + "static/media/10.c631a850.mp3";